import React from "react"

interface SectionHeaderProps {
  title: string
  children?: React.ReactNode
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, children }) => {
  return (
    <h3 className="font-semibold flex items-center gap-2">
      {title}
      {children}
    </h3>
  )
}

export default SectionHeader
